import React from "react";
import "./frames-cards.css";
import { Link } from "react-router-dom";
import Favourite_icon from "../../favourite-icon/Favourite_icon";
import { encodeId } from "../../../../utils/common";

const Frames_card = (props) => {
  return (
    <>
      <section className="Frames_card">
        <Link to={`/product-descrption/${encodeId(props?.id)}`} title={props.name}>
          <div className="imagesec">
            <img
              className="frame_img"
              src={process.env.REACT_APP_IMAGE_URL + props.image}
              alt={props.name || "frame-img"}
            />
          </div>

          <div className="card-content">
            {/* the category line only shows where a page passes a type */}
            {props.type ? <p className="type">{props.type}</p> : null}
            {/* full product name on hover */}
            <p className="name" title={props.name}>
              {props.name}
            </p>
            <p className="prise">
              ₹<span>{props.prise}</span>-
              <span className="oldprise">₹{props.oldprise}</span>
            </p>
          </div>
        </Link>
        {props?.vto_enable && (
          <button
            className="vto-similar-tryon"
            onClick={() => {
              props.setSelectedProduct();
            }}
          >
            Try On
          </button>
        )}
        <div className="faviconoverlay">
          <Favourite_icon id={props?.id} />
        </div>
      </section>
    </>
  );
};

export default Frames_card;